// source: conditionOrderMsg.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf')
var goog = jspb
var global = Function('return this')()

goog.exportSymbol('proto.ConditionOrderPbMsg', null, global)
goog.exportSymbol('proto.ConditionOrderPbMsg.OrderConditionPbMsg', null, global)
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ConditionOrderPbMsg = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.ConditionOrderPbMsg, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ConditionOrderPbMsg.displayName = 'proto.ConditionOrderPbMsg'
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.ConditionOrderPbMsg.OrderConditionPbMsg, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ConditionOrderPbMsg.OrderConditionPbMsg.displayName = 'proto.ConditionOrderPbMsg.OrderConditionPbMsg'
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.ConditionOrderPbMsg.prototype.toObject = function (opt_includeInstance) {
    return proto.ConditionOrderPbMsg.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.ConditionOrderPbMsg} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.ConditionOrderPbMsg.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, 0),
        orderid: jspb.Message.getFieldWithDefault(msg, 2, 0),
        contractcode: jspb.Message.getFieldWithDefault(msg, 3, ''),
        contractdirection: jspb.Message.getFieldWithDefault(msg, 4, 0),
        base: jspb.Message.getFieldWithDefault(msg, 5, ''),
        quote: jspb.Message.getFieldWithDefault(msg, 6, ''),
        userid: jspb.Message.getFieldWithDefault(msg, 7, 0),
        side: jspb.Message.getFieldWithDefault(msg, 8, ''),
        detailside: jspb.Message.getFieldWithDefault(msg, 9, ''),
        clazz: jspb.Message.getFieldWithDefault(msg, 10, 0),
        mustmaker: jspb.Message.getFieldWithDefault(msg, 11, 0),
        amount: jspb.Message.getFieldWithDefault(msg, 12, ''),
        price: jspb.Message.getFieldWithDefault(msg, 13, ''),
        direction: jspb.Message.getFieldWithDefault(msg, 14, ''),
        triggerby: jspb.Message.getFieldWithDefault(msg, 15, ''),
        triggerprice: jspb.Message.getFieldWithDefault(msg, 16, ''),
        openmargin: jspb.Message.getFieldWithDefault(msg, 17, ''),
        extramargin: jspb.Message.getFieldWithDefault(msg, 18, ''),
        avgmargin: jspb.Message.getFieldWithDefault(msg, 19, ''),
        status: jspb.Message.getFieldWithDefault(msg, 20, 0),
        systemtype: jspb.Message.getFieldWithDefault(msg, 21, 0),
        profit: jspb.Message.getFieldWithDefault(msg, 22, ''),
        fee: jspb.Message.getFieldWithDefault(msg, 23, ''),
        reason: jspb.Message.getFieldWithDefault(msg, 24, 0),
        createddate: jspb.Message.getFieldWithDefault(msg, 25, 0),
        indexbase: jspb.Message.getFieldWithDefault(msg, 26, ''),
        stoplimittype: jspb.Message.getFieldWithDefault(msg, 27, 0),
        orderpricetype: jspb.Message.getFieldWithDefault(msg, 28, 0),
        lever: jspb.Message.getFieldWithDefault(msg, 29, 0),
        refconditionorderid: jspb.Message.getFieldWithDefault(msg, 30, 0),
        unitamount: jspb.Message.getFieldWithDefault(msg, 31, ''),
        margindigit: jspb.Message.getFieldWithDefault(msg, 32, 0),
        positiontype: jspb.Message.getFieldWithDefault(msg, 33, 0),
        dealamount: jspb.Message.getFieldWithDefault(msg, 34, ''),
        triggerdate: jspb.Message.getFieldWithDefault(msg, 35, 0),
        modifydate: jspb.Message.getFieldWithDefault(msg, 36, 0),
        marketpricedigit: jspb.Message.getFieldWithDefault(msg, 37, 0),
        basedisplayname: jspb.Message.getFieldWithDefault(msg, 38, ''),
        quotedisplayname: jspb.Message.getFieldWithDefault(msg, 39, ''),
        indexbasedisplayname: jspb.Message.getFieldWithDefault(msg, 40, ''),
        env: jspb.Message.getFieldWithDefault(msg, 41, 0),
        dualposition: jspb.Message.getFieldWithDefault(msg, 42, 0),
        reduceonly: jspb.Message.getFieldWithDefault(msg, 43, 0),
        ordertype: jspb.Message.getFieldWithDefault(msg, 44, 0),
        brokerid: jspb.Message.getFieldWithDefault(msg, 45, 0),
        dealmarket: jspb.Message.getFieldWithDefault(msg, 46, 0),
        mode: jspb.Message.getFieldWithDefault(msg, 47, 0),
        selectedmode: jspb.Message.getFieldWithDefault(msg, 48, 0),
        positionid: jspb.Message.getFieldWithDefault(msg, 49, 0),
        merge: jspb.Message.getFieldWithDefault(msg, 50, 0),
        mergeid: jspb.Message.getFieldWithDefault(msg, 51, 0),
        alltype: jspb.Message.getFieldWithDefault(msg, 52, 0),
        stoploss: (f = msg.getStoploss()) && proto.ConditionOrderPbMsg.OrderConditionPbMsg.toObject(includeInstance, f),
        stopprofit:
          (f = msg.getStopprofit()) && proto.ConditionOrderPbMsg.OrderConditionPbMsg.toObject(includeInstance, f),
        liquidationdate: jspb.Message.getFieldWithDefault(msg, 55, 0),
        contracttype: jspb.Message.getFieldWithDefault(msg, 56, ''),
        biztype: jspb.Message.getFieldWithDefault(msg, 57, ''),
        basecontractcode: jspb.Message.getFieldWithDefault(msg, 58, ''),
        contractliquidatedate: jspb.Message.getFieldWithDefault(msg, 59, 0),
        tracingcallback: jspb.Message.getFieldWithDefault(msg, 60, ''),
        tracingprice: jspb.Message.getFieldWithDefault(msg, 61, ''),
        tracingdirection: jspb.Message.getFieldWithDefault(msg, 62, ''),
        tracingorderpricetype: jspb.Message.getFieldWithDefault(msg, 63, 0),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ConditionOrderPbMsg}
 */
proto.ConditionOrderPbMsg.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.ConditionOrderPbMsg()
  return proto.ConditionOrderPbMsg.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ConditionOrderPbMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ConditionOrderPbMsg}
 */
proto.ConditionOrderPbMsg.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setId(value)
        break
      case 2:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setOrderid(value)
        break
      case 3:
        var value = /** @type {string} */ (reader.readString())
        msg.setContractcode(value)
        break
      case 4:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setContractdirection(value)
        break
      case 5:
        var value = /** @type {string} */ (reader.readString())
        msg.setBase(value)
        break
      case 6:
        var value = /** @type {string} */ (reader.readString())
        msg.setQuote(value)
        break
      case 7:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setUserid(value)
        break
      case 8:
        var value = /** @type {string} */ (reader.readString())
        msg.setSide(value)
        break
      case 9:
        var value = /** @type {string} */ (reader.readString())
        msg.setDetailside(value)
        break
      case 10:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setClazz(value)
        break
      case 11:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMustmaker(value)
        break
      case 12:
        var value = /** @type {string} */ (reader.readString())
        msg.setAmount(value)
        break
      case 13:
        var value = /** @type {string} */ (reader.readString())
        msg.setPrice(value)
        break
      case 14:
        var value = /** @type {string} */ (reader.readString())
        msg.setDirection(value)
        break
      case 15:
        var value = /** @type {string} */ (reader.readString())
        msg.setTriggerby(value)
        break
      case 16:
        var value = /** @type {string} */ (reader.readString())
        msg.setTriggerprice(value)
        break
      case 17:
        var value = /** @type {string} */ (reader.readString())
        msg.setOpenmargin(value)
        break
      case 18:
        var value = /** @type {string} */ (reader.readString())
        msg.setExtramargin(value)
        break
      case 19:
        var value = /** @type {string} */ (reader.readString())
        msg.setAvgmargin(value)
        break
      case 20:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setStatus(value)
        break
      case 21:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setSystemtype(value)
        break
      case 22:
        var value = /** @type {string} */ (reader.readString())
        msg.setProfit(value)
        break
      case 23:
        var value = /** @type {string} */ (reader.readString())
        msg.setFee(value)
        break
      case 24:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setReason(value)
        break
      case 25:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setCreateddate(value)
        break
      case 26:
        var value = /** @type {string} */ (reader.readString())
        msg.setIndexbase(value)
        break
      case 27:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setStoplimittype(value)
        break
      case 28:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setOrderpricetype(value)
        break
      case 29:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setLever(value)
        break
      case 30:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setRefconditionorderid(value)
        break
      case 31:
        var value = /** @type {string} */ (reader.readString())
        msg.setUnitamount(value)
        break
      case 32:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMargindigit(value)
        break
      case 33:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setPositiontype(value)
        break
      case 34:
        var value = /** @type {string} */ (reader.readString())
        msg.setDealamount(value)
        break
      case 35:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setTriggerdate(value)
        break
      case 36:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setModifydate(value)
        break
      case 37:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMarketpricedigit(value)
        break
      case 38:
        var value = /** @type {string} */ (reader.readString())
        msg.setBasedisplayname(value)
        break
      case 39:
        var value = /** @type {string} */ (reader.readString())
        msg.setQuotedisplayname(value)
        break
      case 40:
        var value = /** @type {string} */ (reader.readString())
        msg.setIndexbasedisplayname(value)
        break
      case 41:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setEnv(value)
        break
      case 42:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setDualposition(value)
        break
      case 43:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setReduceonly(value)
        break
      case 44:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setOrdertype(value)
        break
      case 45:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setBrokerid(value)
        break
      case 46:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setDealmarket(value)
        break
      case 47:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMode(value)
        break
      case 48:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setSelectedmode(value)
        break
      case 49:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setPositionid(value)
        break
      case 50:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMerge(value)
        break
      case 51:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setMergeid(value)
        break
      case 52:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setAlltype(value)
        break
      case 53:
        var value = new proto.ConditionOrderPbMsg.OrderConditionPbMsg()
        reader.readMessage(value, proto.ConditionOrderPbMsg.OrderConditionPbMsg.deserializeBinaryFromReader)
        msg.setStoploss(value)
        break
      case 54:
        var value = new proto.ConditionOrderPbMsg.OrderConditionPbMsg()
        reader.readMessage(value, proto.ConditionOrderPbMsg.OrderConditionPbMsg.deserializeBinaryFromReader)
        msg.setStopprofit(value)
        break
      case 55:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setLiquidationdate(value)
        break
      case 56:
        var value = /** @type {string} */ (reader.readString())
        msg.setContracttype(value)
        break
      case 57:
        var value = /** @type {string} */ (reader.readString())
        msg.setBiztype(value)
        break
      case 58:
        var value = /** @type {string} */ (reader.readString())
        msg.setBasecontractcode(value)
        break
      case 59:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setContractliquidatedate(value)
        break
      case 60:
        var value = /** @type {string} */ (reader.readString())
        msg.setTracingcallback(value)
        break
      case 61:
        var value = /** @type {string} */ (reader.readString())
        msg.setTracingprice(value)
        break
      case 62:
        var value = /** @type {string} */ (reader.readString())
        msg.setTracingdirection(value)
        break
      case 63:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setTracingorderpricetype(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ConditionOrderPbMsg.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.ConditionOrderPbMsg.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ConditionOrderPbMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ConditionOrderPbMsg.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getId()
  if (f !== 0) {
    writer.writeInt64(1, f)
  }
  f = message.getOrderid()
  if (f !== 0) {
    writer.writeInt64(2, f)
  }
  f = message.getContractcode()
  if (f.length > 0) {
    writer.writeString(3, f)
  }
  f = message.getContractdirection()
  if (f !== 0) {
    writer.writeInt32(4, f)
  }
  f = message.getBase()
  if (f.length > 0) {
    writer.writeString(5, f)
  }
  f = message.getQuote()
  if (f.length > 0) {
    writer.writeString(6, f)
  }
  f = message.getUserid()
  if (f !== 0) {
    writer.writeInt64(7, f)
  }
  f = message.getSide()
  if (f.length > 0) {
    writer.writeString(8, f)
  }
  f = message.getDetailside()
  if (f.length > 0) {
    writer.writeString(9, f)
  }
  f = message.getClazz()
  if (f !== 0) {
    writer.writeInt32(10, f)
  }
  f = message.getMustmaker()
  if (f !== 0) {
    writer.writeInt32(11, f)
  }
  f = message.getAmount()
  if (f.length > 0) {
    writer.writeString(12, f)
  }
  f = message.getPrice()
  if (f.length > 0) {
    writer.writeString(13, f)
  }
  f = message.getDirection()
  if (f.length > 0) {
    writer.writeString(14, f)
  }
  f = message.getTriggerby()
  if (f.length > 0) {
    writer.writeString(15, f)
  }
  f = message.getTriggerprice()
  if (f.length > 0) {
    writer.writeString(16, f)
  }
  f = message.getOpenmargin()
  if (f.length > 0) {
    writer.writeString(17, f)
  }
  f = message.getExtramargin()
  if (f.length > 0) {
    writer.writeString(18, f)
  }
  f = message.getAvgmargin()
  if (f.length > 0) {
    writer.writeString(19, f)
  }
  f = message.getStatus()
  if (f !== 0) {
    writer.writeInt32(20, f)
  }
  f = message.getSystemtype()
  if (f !== 0) {
    writer.writeInt32(21, f)
  }
  f = message.getProfit()
  if (f.length > 0) {
    writer.writeString(22, f)
  }
  f = message.getFee()
  if (f.length > 0) {
    writer.writeString(23, f)
  }
  f = message.getReason()
  if (f !== 0) {
    writer.writeInt32(24, f)
  }
  f = message.getCreateddate()
  if (f !== 0) {
    writer.writeInt64(25, f)
  }
  f = message.getIndexbase()
  if (f.length > 0) {
    writer.writeString(26, f)
  }
  f = message.getStoplimittype()
  if (f !== 0) {
    writer.writeInt32(27, f)
  }
  f = message.getOrderpricetype()
  if (f !== 0) {
    writer.writeInt32(28, f)
  }
  f = message.getLever()
  if (f !== 0) {
    writer.writeInt32(29, f)
  }
  f = message.getRefconditionorderid()
  if (f !== 0) {
    writer.writeInt64(30, f)
  }
  f = message.getUnitamount()
  if (f.length > 0) {
    writer.writeString(31, f)
  }
  f = message.getMargindigit()
  if (f !== 0) {
    writer.writeInt32(32, f)
  }
  f = message.getPositiontype()
  if (f !== 0) {
    writer.writeInt32(33, f)
  }
  f = message.getDealamount()
  if (f.length > 0) {
    writer.writeString(34, f)
  }
  f = message.getTriggerdate()
  if (f !== 0) {
    writer.writeInt64(35, f)
  }
  f = message.getModifydate()
  if (f !== 0) {
    writer.writeInt64(36, f)
  }
  f = message.getMarketpricedigit()
  if (f !== 0) {
    writer.writeInt32(37, f)
  }
  f = message.getBasedisplayname()
  if (f.length > 0) {
    writer.writeString(38, f)
  }
  f = message.getQuotedisplayname()
  if (f.length > 0) {
    writer.writeString(39, f)
  }
  f = message.getIndexbasedisplayname()
  if (f.length > 0) {
    writer.writeString(40, f)
  }
  f = message.getEnv()
  if (f !== 0) {
    writer.writeInt32(41, f)
  }
  f = message.getDualposition()
  if (f !== 0) {
    writer.writeInt32(42, f)
  }
  f = message.getReduceonly()
  if (f !== 0) {
    writer.writeInt32(43, f)
  }
  f = message.getOrdertype()
  if (f !== 0) {
    writer.writeInt32(44, f)
  }
  f = message.getBrokerid()
  if (f !== 0) {
    writer.writeInt32(45, f)
  }
  f = message.getDealmarket()
  if (f !== 0) {
    writer.writeInt32(46, f)
  }
  f = message.getMode()
  if (f !== 0) {
    writer.writeInt32(47, f)
  }
  f = message.getSelectedmode()
  if (f !== 0) {
    writer.writeInt32(48, f)
  }
  f = message.getPositionid()
  if (f !== 0) {
    writer.writeInt64(49, f)
  }
  f = message.getMerge()
  if (f !== 0) {
    writer.writeInt32(50, f)
  }
  f = message.getMergeid()
  if (f !== 0) {
    writer.writeInt64(51, f)
  }
  f = message.getAlltype()
  if (f !== 0) {
    writer.writeInt32(52, f)
  }
  f = message.getStoploss()
  if (f != null) {
    writer.writeMessage(53, f, proto.ConditionOrderPbMsg.OrderConditionPbMsg.serializeBinaryToWriter)
  }
  f = message.getStopprofit()
  if (f != null) {
    writer.writeMessage(54, f, proto.ConditionOrderPbMsg.OrderConditionPbMsg.serializeBinaryToWriter)
  }
  f = message.getLiquidationdate()
  if (f !== 0) {
    writer.writeInt64(55, f)
  }
  f = message.getContracttype()
  if (f.length > 0) {
    writer.writeString(56, f)
  }
  f = message.getBiztype()
  if (f.length > 0) {
    writer.writeString(57, f)
  }
  f = message.getBasecontractcode()
  if (f.length > 0) {
    writer.writeString(58, f)
  }
  f = message.getContractliquidatedate()
  if (f !== 0) {
    writer.writeInt64(59, f)
  }
  f = message.getTracingcallback()
  if (f.length > 0) {
    writer.writeString(60, f)
  }
  f = message.getTracingprice()
  if (f.length > 0) {
    writer.writeString(61, f)
  }
  f = message.getTracingdirection()
  if (f.length > 0) {
    writer.writeString(62, f)
  }
  f = message.getTracingorderpricetype()
  if (f !== 0) {
    writer.writeInt32(63, f)
  }
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.toObject = function (opt_includeInstance) {
    return proto.ConditionOrderPbMsg.OrderConditionPbMsg.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.ConditionOrderPbMsg.OrderConditionPbMsg} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.ConditionOrderPbMsg.OrderConditionPbMsg.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        contractcode: jspb.Message.getFieldWithDefault(msg, 1, ''),
        createddate: jspb.Message.getFieldWithDefault(msg, 2, 0),
        detailside: jspb.Message.getFieldWithDefault(msg, 3, ''),
        amount: jspb.Message.getFieldWithDefault(msg, 4, ''),
        systemtype: jspb.Message.getFieldWithDefault(msg, 5, 0),
        triggerprice: jspb.Message.getFieldWithDefault(msg, 6, ''),
        status: jspb.Message.getFieldWithDefault(msg, 7, 0),
        stoplimittype: jspb.Message.getFieldWithDefault(msg, 8, 0),
        price: jspb.Message.getFieldWithDefault(msg, 9, ''),
        triggerby: jspb.Message.getFieldWithDefault(msg, 10, ''),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ConditionOrderPbMsg.OrderConditionPbMsg}
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.ConditionOrderPbMsg.OrderConditionPbMsg()
  return proto.ConditionOrderPbMsg.OrderConditionPbMsg.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ConditionOrderPbMsg.OrderConditionPbMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ConditionOrderPbMsg.OrderConditionPbMsg}
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString())
        msg.setContractcode(value)
        break
      case 2:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setCreateddate(value)
        break
      case 3:
        var value = /** @type {string} */ (reader.readString())
        msg.setDetailside(value)
        break
      case 4:
        var value = /** @type {string} */ (reader.readString())
        msg.setAmount(value)
        break
      case 5:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setSystemtype(value)
        break
      case 6:
        var value = /** @type {string} */ (reader.readString())
        msg.setTriggerprice(value)
        break
      case 7:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setStatus(value)
        break
      case 8:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setStoplimittype(value)
        break
      case 9:
        var value = /** @type {string} */ (reader.readString())
        msg.setPrice(value)
        break
      case 10:
        var value = /** @type {string} */ (reader.readString())
        msg.setTriggerby(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.ConditionOrderPbMsg.OrderConditionPbMsg.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ConditionOrderPbMsg.OrderConditionPbMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getContractcode()
  if (f.length > 0) {
    writer.writeString(1, f)
  }
  f = message.getCreateddate()
  if (f !== 0) {
    writer.writeInt64(2, f)
  }
  f = message.getDetailside()
  if (f.length > 0) {
    writer.writeString(3, f)
  }
  f = message.getAmount()
  if (f.length > 0) {
    writer.writeString(4, f)
  }
  f = message.getSystemtype()
  if (f !== 0) {
    writer.writeInt32(5, f)
  }
  f = message.getTriggerprice()
  if (f.length > 0) {
    writer.writeString(6, f)
  }
  f = message.getStatus()
  if (f !== 0) {
    writer.writeInt32(7, f)
  }
  f = message.getStoplimittype()
  if (f !== 0) {
    writer.writeInt32(8, f)
  }
  f = message.getPrice()
  if (f.length > 0) {
    writer.writeString(9, f)
  }
  f = message.getTriggerby()
  if (f.length > 0) {
    writer.writeString(10, f)
  }
}

/**
 * optional string contractCode = 1;
 * @return {string}
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.getContractcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg.OrderConditionPbMsg} returns this
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.setContractcode = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value)
}

/**
 * optional int64 createdDate = 2;
 * @return {number}
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.getCreateddate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg.OrderConditionPbMsg} returns this
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.setCreateddate = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value)
}

/**
 * optional string detailSide = 3;
 * @return {string}
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.getDetailside = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg.OrderConditionPbMsg} returns this
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.setDetailside = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value)
}

/**
 * optional string amount = 4;
 * @return {string}
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.getAmount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg.OrderConditionPbMsg} returns this
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.setAmount = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value)
}

/**
 * optional int32 systemType = 5;
 * @return {number}
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.getSystemtype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg.OrderConditionPbMsg} returns this
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.setSystemtype = function (value) {
  return jspb.Message.setProto3IntField(this, 5, value)
}

/**
 * optional string triggerPrice = 6;
 * @return {string}
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.getTriggerprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg.OrderConditionPbMsg} returns this
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.setTriggerprice = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value)
}

/**
 * optional int32 status = 7;
 * @return {number}
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.getStatus = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg.OrderConditionPbMsg} returns this
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.setStatus = function (value) {
  return jspb.Message.setProto3IntField(this, 7, value)
}

/**
 * optional int32 stopLimitType = 8;
 * @return {number}
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.getStoplimittype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg.OrderConditionPbMsg} returns this
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.setStoplimittype = function (value) {
  return jspb.Message.setProto3IntField(this, 8, value)
}

/**
 * optional string price = 9;
 * @return {string}
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.getPrice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg.OrderConditionPbMsg} returns this
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.setPrice = function (value) {
  return jspb.Message.setProto3StringField(this, 9, value)
}

/**
 * optional string triggerBy = 10;
 * @return {string}
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.getTriggerby = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg.OrderConditionPbMsg} returns this
 */
proto.ConditionOrderPbMsg.OrderConditionPbMsg.prototype.setTriggerby = function (value) {
  return jspb.Message.setProto3StringField(this, 10, value)
}

/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setId = function (value) {
  return jspb.Message.setProto3IntField(this, 1, value)
}

/**
 * optional int64 orderId = 2;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getOrderid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setOrderid = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value)
}

/**
 * optional string contractCode = 3;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getContractcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setContractcode = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value)
}

/**
 * optional int32 contractDirection = 4;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getContractdirection = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setContractdirection = function (value) {
  return jspb.Message.setProto3IntField(this, 4, value)
}

/**
 * optional string base = 5;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getBase = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setBase = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value)
}

/**
 * optional string quote = 6;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getQuote = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setQuote = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value)
}

/**
 * optional int64 userId = 7;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setUserid = function (value) {
  return jspb.Message.setProto3IntField(this, 7, value)
}

/**
 * optional string side = 8;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getSide = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setSide = function (value) {
  return jspb.Message.setProto3StringField(this, 8, value)
}

/**
 * optional string detailSide = 9;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getDetailside = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setDetailside = function (value) {
  return jspb.Message.setProto3StringField(this, 9, value)
}

/**
 * optional int32 clazz = 10;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getClazz = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setClazz = function (value) {
  return jspb.Message.setProto3IntField(this, 10, value)
}

/**
 * optional int32 mustMaker = 11;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getMustmaker = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setMustmaker = function (value) {
  return jspb.Message.setProto3IntField(this, 11, value)
}

/**
 * optional string amount = 12;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getAmount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setAmount = function (value) {
  return jspb.Message.setProto3StringField(this, 12, value)
}

/**
 * optional string price = 13;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getPrice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setPrice = function (value) {
  return jspb.Message.setProto3StringField(this, 13, value)
}

/**
 * optional string direction = 14;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getDirection = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setDirection = function (value) {
  return jspb.Message.setProto3StringField(this, 14, value)
}

/**
 * optional string triggerBy = 15;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getTriggerby = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setTriggerby = function (value) {
  return jspb.Message.setProto3StringField(this, 15, value)
}

/**
 * optional string triggerPrice = 16;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getTriggerprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setTriggerprice = function (value) {
  return jspb.Message.setProto3StringField(this, 16, value)
}

/**
 * optional string openMargin = 17;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getOpenmargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setOpenmargin = function (value) {
  return jspb.Message.setProto3StringField(this, 17, value)
}

/**
 * optional string extraMargin = 18;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getExtramargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setExtramargin = function (value) {
  return jspb.Message.setProto3StringField(this, 18, value)
}

/**
 * optional string avgMargin = 19;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getAvgmargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setAvgmargin = function (value) {
  return jspb.Message.setProto3StringField(this, 19, value)
}

/**
 * optional int32 status = 20;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getStatus = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setStatus = function (value) {
  return jspb.Message.setProto3IntField(this, 20, value)
}

/**
 * optional int32 systemType = 21;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getSystemtype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setSystemtype = function (value) {
  return jspb.Message.setProto3IntField(this, 21, value)
}

/**
 * optional string profit = 22;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getProfit = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setProfit = function (value) {
  return jspb.Message.setProto3StringField(this, 22, value)
}

/**
 * optional string fee = 23;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getFee = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setFee = function (value) {
  return jspb.Message.setProto3StringField(this, 23, value)
}

/**
 * optional int32 reason = 24;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getReason = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setReason = function (value) {
  return jspb.Message.setProto3IntField(this, 24, value)
}

/**
 * optional int64 createdDate = 25;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getCreateddate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setCreateddate = function (value) {
  return jspb.Message.setProto3IntField(this, 25, value)
}

/**
 * optional string indexBase = 26;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getIndexbase = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setIndexbase = function (value) {
  return jspb.Message.setProto3StringField(this, 26, value)
}

/**
 * optional int32 stopLimitType = 27;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getStoplimittype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setStoplimittype = function (value) {
  return jspb.Message.setProto3IntField(this, 27, value)
}

/**
 * optional int32 orderPriceType = 28;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getOrderpricetype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setOrderpricetype = function (value) {
  return jspb.Message.setProto3IntField(this, 28, value)
}

/**
 * optional int32 lever = 29;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getLever = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setLever = function (value) {
  return jspb.Message.setProto3IntField(this, 29, value)
}

/**
 * optional int64 refConditionOrderId = 30;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getRefconditionorderid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setRefconditionorderid = function (value) {
  return jspb.Message.setProto3IntField(this, 30, value)
}

/**
 * optional string unitAmount = 31;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getUnitamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setUnitamount = function (value) {
  return jspb.Message.setProto3StringField(this, 31, value)
}

/**
 * optional int32 marginDigit = 32;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getMargindigit = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setMargindigit = function (value) {
  return jspb.Message.setProto3IntField(this, 32, value)
}

/**
 * optional int32 positionType = 33;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getPositiontype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setPositiontype = function (value) {
  return jspb.Message.setProto3IntField(this, 33, value)
}

/**
 * optional string dealAmount = 34;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getDealamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setDealamount = function (value) {
  return jspb.Message.setProto3StringField(this, 34, value)
}

/**
 * optional int64 triggerDate = 35;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getTriggerdate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setTriggerdate = function (value) {
  return jspb.Message.setProto3IntField(this, 35, value)
}

/**
 * optional int64 modifyDate = 36;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getModifydate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 36, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setModifydate = function (value) {
  return jspb.Message.setProto3IntField(this, 36, value)
}

/**
 * optional int32 marketPriceDigit = 37;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getMarketpricedigit = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 37, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setMarketpricedigit = function (value) {
  return jspb.Message.setProto3IntField(this, 37, value)
}

/**
 * optional string baseDisplayName = 38;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getBasedisplayname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setBasedisplayname = function (value) {
  return jspb.Message.setProto3StringField(this, 38, value)
}

/**
 * optional string quoteDisplayName = 39;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getQuotedisplayname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setQuotedisplayname = function (value) {
  return jspb.Message.setProto3StringField(this, 39, value)
}

/**
 * optional string indexBaseDisplayName = 40;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getIndexbasedisplayname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setIndexbasedisplayname = function (value) {
  return jspb.Message.setProto3StringField(this, 40, value)
}

/**
 * optional int32 env = 41;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getEnv = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 41, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setEnv = function (value) {
  return jspb.Message.setProto3IntField(this, 41, value)
}

/**
 * optional int32 dualPosition = 42;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getDualposition = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 42, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setDualposition = function (value) {
  return jspb.Message.setProto3IntField(this, 42, value)
}

/**
 * optional int32 reduceOnly = 43;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getReduceonly = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 43, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setReduceonly = function (value) {
  return jspb.Message.setProto3IntField(this, 43, value)
}

/**
 * optional int32 orderType = 44;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getOrdertype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 44, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setOrdertype = function (value) {
  return jspb.Message.setProto3IntField(this, 44, value)
}

/**
 * optional int32 brokerId = 45;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getBrokerid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 45, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setBrokerid = function (value) {
  return jspb.Message.setProto3IntField(this, 45, value)
}

/**
 * optional int32 dealMarket = 46;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getDealmarket = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 46, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setDealmarket = function (value) {
  return jspb.Message.setProto3IntField(this, 46, value)
}

/**
 * optional int32 mode = 47;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getMode = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 47, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setMode = function (value) {
  return jspb.Message.setProto3IntField(this, 47, value)
}

/**
 * optional int32 selectedMode = 48;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getSelectedmode = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 48, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setSelectedmode = function (value) {
  return jspb.Message.setProto3IntField(this, 48, value)
}

/**
 * optional int64 positionId = 49;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getPositionid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 49, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setPositionid = function (value) {
  return jspb.Message.setProto3IntField(this, 49, value)
}

/**
 * optional int32 merge = 50;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getMerge = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 50, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setMerge = function (value) {
  return jspb.Message.setProto3IntField(this, 50, value)
}

/**
 * optional int64 mergeId = 51;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getMergeid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 51, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setMergeid = function (value) {
  return jspb.Message.setProto3IntField(this, 51, value)
}

/**
 * optional int32 allType = 52;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getAlltype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 52, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setAlltype = function (value) {
  return jspb.Message.setProto3IntField(this, 52, value)
}

/**
 * optional OrderConditionPbMsg stopLoss = 53;
 * @return {?proto.ConditionOrderPbMsg.OrderConditionPbMsg}
 */
proto.ConditionOrderPbMsg.prototype.getStoploss = function () {
  return /** @type{?proto.ConditionOrderPbMsg.OrderConditionPbMsg} */ (
    jspb.Message.getWrapperField(this, proto.ConditionOrderPbMsg.OrderConditionPbMsg, 53)
  )
}

/**
 * @param {?proto.ConditionOrderPbMsg.OrderConditionPbMsg|undefined} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setStoploss = function (value) {
  return jspb.Message.setWrapperField(this, 53, value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.clearStoploss = function () {
  return this.setStoploss(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ConditionOrderPbMsg.prototype.hasStoploss = function () {
  return jspb.Message.getField(this, 53) != null
}

/**
 * optional OrderConditionPbMsg stopProfit = 54;
 * @return {?proto.ConditionOrderPbMsg.OrderConditionPbMsg}
 */
proto.ConditionOrderPbMsg.prototype.getStopprofit = function () {
  return /** @type{?proto.ConditionOrderPbMsg.OrderConditionPbMsg} */ (
    jspb.Message.getWrapperField(this, proto.ConditionOrderPbMsg.OrderConditionPbMsg, 54)
  )
}

/**
 * @param {?proto.ConditionOrderPbMsg.OrderConditionPbMsg|undefined} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setStopprofit = function (value) {
  return jspb.Message.setWrapperField(this, 54, value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.clearStopprofit = function () {
  return this.setStopprofit(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.ConditionOrderPbMsg.prototype.hasStopprofit = function () {
  return jspb.Message.getField(this, 54) != null
}

/**
 * optional int64 liquidationDate = 55;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getLiquidationdate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 55, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setLiquidationdate = function (value) {
  return jspb.Message.setProto3IntField(this, 55, value)
}

/**
 * optional string contractType = 56;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getContracttype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 56, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setContracttype = function (value) {
  return jspb.Message.setProto3StringField(this, 56, value)
}

/**
 * optional string bizType = 57;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getBiztype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 57, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setBiztype = function (value) {
  return jspb.Message.setProto3StringField(this, 57, value)
}

/**
 * optional string baseContractCode = 58;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getBasecontractcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 58, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setBasecontractcode = function (value) {
  return jspb.Message.setProto3StringField(this, 58, value)
}

/**
 * optional int64 contractLiquidateDate = 59;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getContractliquidatedate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 59, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setContractliquidatedate = function (value) {
  return jspb.Message.setProto3IntField(this, 59, value)
}

/**
 * optional string tracingCallback = 60;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getTracingcallback = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 60, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setTracingcallback = function (value) {
  return jspb.Message.setProto3StringField(this, 60, value)
}

/**
 * optional string tracingPrice = 61;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getTracingprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 61, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setTracingprice = function (value) {
  return jspb.Message.setProto3StringField(this, 61, value)
}

/**
 * optional string tracingDirection = 62;
 * @return {string}
 */
proto.ConditionOrderPbMsg.prototype.getTracingdirection = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 62, ''))
}

/**
 * @param {string} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setTracingdirection = function (value) {
  return jspb.Message.setProto3StringField(this, 62, value)
}

/**
 * optional int32 tracingOrderPriceType = 63;
 * @return {number}
 */
proto.ConditionOrderPbMsg.prototype.getTracingorderpricetype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 63, 0))
}

/**
 * @param {number} value
 * @return {!proto.ConditionOrderPbMsg} returns this
 */
proto.ConditionOrderPbMsg.prototype.setTracingorderpricetype = function (value) {
  return jspb.Message.setProto3IntField(this, 63, value)
}

goog.object.extend(exports, proto)
